import React, { useEffect, useState } from "react";
import "../css/reset.css";
import "../css/service.css";

const servicesData = [
  // {
  //   title: "AI챗봇",
  //   items: [
  //     "Chat GPT, GPTs, Gemini",
  //     "요약 및 문서 생성",
  //     "카카오채널 등 SNS 연결",
  //     "DB, 웹사이트, 문서 학습",
  //   ],
  //   frameClass: "box_frame_1",
  // },
  {
    title: "앱개발",
    items: [
      "React Native",
      "Kotlin",
      "IoT 연동 앱",
      "하이브리드 앱",
      "애드몹 수익형앱",
    ],
    frameClass: "box_frame_2",
  },
  {
    title: "웹서비스",
    items: ["홈페이지 개발", "쇼핑몰 개발", "클라우드 SaaS 개발", "부하테스트"],
    frameClass: "box_frame_3",
  },
  // {
  //   title: "데이터 분석",
  //   items: [
  //     "머신러닝/딥러닝",
  //     "연합러닝",
  //     "자연어처리",
  //     "크롤링",
  //     "데이터 시각화",
  //   ],
  //   frameClass: "box_frame_4",
  // },
];

const Service = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleMouseEnter = (index) => {
    setActiveIndex(index);
  };

  const [VW, setVW] = useState(window.innerWidth);
  // var viewPort = (648 / 768) * VW
  const handleResize = () => {
    setVW(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <section
        className="service_wrap"
        id="serviceSection"
        name="serviceSection"
      >
        <div className="service_inner">
          <div className="title_wrap">
            <h3>SERVICE 1.</h3>
            <strong>데이터파이브 주요 서비스</strong>
          </div>

          <div className="service_produce_wrap">
            <p>DATAFIVE는 고객의 가치를 실현해드립니다.</p>
            <span>
              안드로이드 및 아이폰 앱-웹과 서버 개발을 수행하며, 관리자용
              사이트도 개발합니다.
              <br />
              다양한 스마트 서비스의 구현을 위해 컨설팅, 시스템 분석, 설계,
              개발, 유지보수 등을 통해 지속적인 성장이 가능한 체계를 구축하여
              제공합니다.
            </span>
          </div>

          <div className="service_content_wrap">
            {servicesData.map((service, index) => (
              <div
                key={index}
                className={`service_box ${
                  activeIndex === index ? "active" : ""
                }`}
                onMouseEnter={() => handleMouseEnter(index)}
              >
                <div className="box_frame">
                  <span className={service.frameClass}></span>
                </div>
                <div className="box_content">
                  <strong>{service.title}</strong>
                  <ul>
                    {service.items.map((item, itemIndex) => (
                      <li key={itemIndex}>{item}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Service;
